import { createMaps, drawPolygon as _drawPolygon, drawBoundaryByName, drawMultipleBoundaries, drawChinaProvinceBoundaries } from "@/utils/mapCommon.js";
export default {
  data() {
    return {
      map: null,
      mapCenter: [116.404, 39.915],
      markPoints: [],
      provinceBoundaries: [], // 存储省级边界
      mapStyle: "normal", // 默认样式，子组件可以覆盖
    };
  },
  mounted() {
    // 延迟到下一个tick，确保子组件的mapStyle已经被设置
    this.$nextTick(() => {
      let el = this.$refs.zfyxMap;
      // 使用子组件中设置的mapStyle，如果没有设置则使用默认值'normal'
      const style = this.mapStyle || 'normal';
      console.log('🗺️ Map mixin初始化，使用样式:', style);
      this.map = createMaps(el, this.mapCenter, 15, style);
    });
  },
  methods: {
    /**
     * 绘制全国省级行政边界
     * 使用百度地图官方 DistrictLayer 绘制所有省份轮廓
     * @param {Object} options - 配置选项
     * @param {Object} options.styles - 样式配置
     * @returns {Object} 返回行政区划图层对象
     */
    drawAllProvinceBoundaries(options = {}) {
      const districtLayer = drawChinaProvinceBoundaries(this.map, options);
      this.provinceBoundaries = districtLayer;
      return districtLayer;
    },
    /**
     * 绘制地图多边形
     */
    drawPolygon(item, events = {}) {
      return _drawPolygon(item.boundary, { styles: {}, events }, this.map);
    },
    /**
     * 使用百度地图 API 绘制城市行政边界
     * @param {String} cityName - 城市名称，如 "北京市"、"上海市"
     * @param {Object} options - 配置选项
     * @param {Object} options.styles - 多边形样式
     * @param {Object} options.events - 事件绑定
     * @returns {Promise} 返回 Promise，resolve 绘制的多边形数组
     */
    drawCityBoundary(cityName, options = {}) {
      return drawBoundaryByName(this.map, cityName, options);
    },
    /**
     * 批量绘制多个城市的行政边界
     * @param {Array} cityNames - 城市名称数组
     * @param {Object} options - 配置选项
     * @returns {Promise} 返回 Promise，resolve 所有绘制的多边形
     */
    drawMultipleCityBoundaries(cityNames, options = {}) {
      return drawMultipleBoundaries(this.map, cityNames, options);
    },
    /**
     * 用RichMark绘制地图覆盖物
     */
    drawRichMark(point, html = ``, offset = [0, 0], map = this.map, events) {
      let markerObj = {
        type: "richMark",
        item: new BMapGLLib.RichMarker(html, point, {
          anchor: new BMapGL.Size(offset[0], offset[1]),
        }),
      };
      map.addOverlay(markerObj.item);
      // this._overlays.push(markerObj);
      this.bindMarkEvent(markerObj, events, point);
      return markerObj.item;
    },
    //mark绑定事件
    bindMarkEvent(markerObj, events, point) {
      //默认事件
      let eventsConfig = Object.assign(
        {},
        {
          click: null,
          mouseover: null,
          mouseout: null,
          dblclick: null,
        },
        events
      );
      let keys = Object.keys(eventsConfig);
      //绑定事件
      keys.forEach((keyName) => {
        let event = eventsConfig[keyName];
        if (event) {
          markerObj.item.addEventListener(keyName, () => {
            eventsConfig[keyName](markerObj.item, point);
          });
        }
      });
    },
    setViewport(pointsArr = this.markPoints, map = this.map) {
      map.setViewport(pointsArr, { margins: [0, 0, 0, 0], zoomFactor: 0 });
    },
  },
  /**
   * 路由切换，释放内存
   */
  beforeDestroy() {
    // 清除所有边界覆盖物
    if (this.provinceBoundaries && this.provinceBoundaries.length > 0) {
      this.provinceBoundaries.forEach((item) => {
        if (item.polygon) {
          this.map.removeOverlay(item.polygon);
        }
      });
      this.provinceBoundaries = [];
    }

    // 清除所有覆盖物
    if (this.map) {
      this.map.clearOverlays();
      this.map = null;
    }
  },
};
